import Vue from 'vue'
import moment from 'moment'

// Vue Material
import VueMaterial from 'vue-material'
Vue.use(VueMaterial)
import 'vue-material/dist/vue-material.css'

Vue.material.registerTheme({
  default: {
    primary: 'red',
    hue: 900
  },
  'light-blue': {
    primary: 'white',
    accent: 'white',
    warn: 'white',
    background: 'white'
  }
})

// import pt from 'vee-validate/dist/locale/pt_BR'
import VeeValidate, { Validator } from 'vee-validate'

// Setting this 'cause it will be removed error by fields repeated names components
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
})

// Add locale helper.
// Validator.addLocale(pt)
// Validator.installDateTimeValidators(moment)

Validator.extend('not_future_date', value => {
  var maxData = new Date()
  var valueDate = moment(value, 'DD/MM/YYYY')
  var inputData = new Date(valueDate)
  return inputData.getTime() <= maxData.getTime()
})

Validator.extend('date_range', {
  getMessage: field => 'Mínimo 10 dias antes e máximo 45 dias após da data atual',
  validate: value => {
    const minDate = moment().subtract(10, 'days').startOf('day')
    const maxDate = moment().add(45, 'days').endOf('day')
    const date = moment(value, 'DD/MM/YYYY')
    return date.isBetween(minDate, maxDate, null, '[]')
  }
})

import { isCPFValid } from './validate-cpf'
Validator.extend('cpf_valid', value => {
  return isCPFValid(value)
})

Validator.extend('beforeLimit', (value, limitDays) => {
  if (!value || !limitDays) {
    return true
  }

  var minDateValue = moment().subtract(parseInt(limitDays), 'day').startOf('day')
  var minDate = new Date(minDateValue)
  var valueDate = moment(value, 'DD/MM/YYYY')
  var inputData = new Date(valueDate)
  return inputData.getTime() >= minDate.getTime()
})

Validator.extend('check_date_format', (value, format) => {
  return moment(value, format[0], true).isValid()
})

Validator.extend('after_date', (value, afterAge) => {
  let valueDate = moment(value, 'DD/MM/YYYY')
  let afterDate = moment(afterAge[0], 'DD/MM/YYYY')
  return afterDate.isBefore(valueDate)
})

Vue.use(VeeValidate, {
  locale: 'pt_BR'
})

// Vue-tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
import 'vue-tour/dist/vue-tour.css'

// Vuetify
import Vuetify from 'vuetify'
Vue.use(Vuetify)

// Vue-chartjs
import VueChartjs from 'vue-chartjs'
Vue.use(VueChartjs)

// Vue2-datepicker
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
// import '../static/stylesheets/vue2-datepicker.scss'
Vue.use(DatePicker)

// Vue-datepicker
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
Vue.use(VCalendar, {
  locale: 'pt-BR',
  datePickerUpdateOnInput: true,
  popoverVisibility: 'focus',
  themeStyles: {
    wrapper: {
      color: '#fafafa',
      border: '0',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
      borderRadius: '5px'
    },
    header: {
      padding: `20px 15px`
    },
    headerHorizontalDivider: {
      borderTop: 'solid rgba(94, 92, 92, 0.2) 1px',
      width: '80%'
    },
    weekdays: {
      color: '#7f1a54',
      fontWeight: '600',
      padding: `20px 15px 5px 15px`
    },
    weeks: {
      padding: `0 15px 15px 15px`
    },
    dayContent: {
      fontSize: '0.9rem'
    }
  }
})

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY || '',
    libraries: 'places'
  }
})

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
